<template>
    <v-row align="center" justify="center" class="py-2 px-3" no-gutters>
        <v-col cols="12">
            <span class="d-block text-center text-caption">Enter in the average value of a patient referral.</span>
        </v-col>
        <v-col cols="auto">
            <v-text-field 
                v-model="customerValue"
                :rules="numberRules"
                label="Customer value"
                style="max-width: 90px"/>
        </v-col>
        
        <v-col cols="auto" class="mx-2 text-h6 font-weight-light">=</v-col>
        <v-col cols="auto text-h4">
            {{ this.calculatedROI() }}
        </v-col>

        <v-col cols="12" class="text-center">
            <v-checkbox
                dense
                v-model="onlyNew"
                class="d-inline-block ma-0 pa-0"
                color="ddlightblue">
                <template v-slot:label>
                    <small>Calculate only for new patients</small>
                </template>
            </v-checkbox>
        </v-col>
    </v-row>
</template>

<script>

import { LongNumber } from '@/mixins/filters'; 

/**
 * RoiCalculator component is a visual component that allows to the user to 
 * enter the average value of a referral to calculate the return of inversion 
 * based on the customer number of referrals. It also format the returned value
 * to prevent text overflow.
 */
export default {
    name: 'RoiCalculator',
    props: {
        referrals: {
            required: true,
            default: '0.0'
        },
        newPatients: {
            required: true,
            default: '0.0'
        }
    },
    data: () => ({
        customerValue: 100,
        onlyNew: false,
        numberRules: [
            value => !!value && !isNaN(value) || 'Only numbers.'
        ]
    }),
    computed: {
        factor: function() {
            let value = this.referrals;
            if (this.onlyNew) {
                value = (parseFloat(this.referrals) * parseFloat(this.newPatients) / 100).toString()
            }

            return parseFloat(value.replace(',',''));
        }
    },
    methods: {
        calculatedROI() {
            const factor = parseFloat(this.referrals.replace(',',''));
            let result = factor * this.customerValue;
            if (this.onlyNew) result *= parseFloat(this.newPatients) / 100;

            if (isNaN(result)) return '-';

            const formattedResult = LongNumber(result);

            if (this.customerValue > 0) {
                    let value = JSON.stringify({
                    customerValue: this.customerValue,
                    customerReferrals: this.referrals,
                    result: formattedResult
                });
                window.GA.trackEvent('roi_calculator_calc', value);
            }
            return `${formattedResult} $`;
        }
    }
}
</script>